Object.defineProperty(exports, "__esModule", { value: true });
var AssociateBy = /** @class */ (function () {
    function AssociateBy() {
    }
    AssociateBy.prototype.associateBy = function (keyOrSelector, valueTransform) {
        var selector = typeof keyOrSelector === "function"
            ? keyOrSelector
            : function (value) { return value[keyOrSelector]; };
        var result = new Map();
        var transform = valueTransform != null
            ? valueTransform
            : function (value) { return value; };
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            var key = selector(item.value);
            var value = transform(item.value);
            result.set(key, value);
        }
        return result;
    };
    return AssociateBy;
}());
exports.AssociateBy = AssociateBy;
//# sourceMappingURL=associateBy.js.map